export default "__VITE_ASSET__BmL_$BmB__"